import { HttpStatus } from '@philips-internal/oswald-ui-core/lib/services/index.js';
class FileHandlerConfiguration {
    constructor() {
        this.errorResponseState = HttpStatus.INTERNAL_SERVER_ERROR;
        this.previewUrl = '';
        this.removeResponseState = HttpStatus.OK;
        this.removeUrl = '';
        this.uploadResponseState = HttpStatus.CREATED;
        this.uploadUrl = '';
    }
}
export { FileHandlerConfiguration, };
//# sourceMappingURL=file-service-types.js.map